import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';

@Component({
  selector: 'app-eap',
  templateUrl: './eap.component.html',
  styleUrls: ['./eap.component.scss'],
})
export class EapComponent implements OnInit {
  content: any;
  constructor(private httpDash: DashboardService,
    private generalServe: GeneralService,) {}

  ngOnInit(): void {
    this.getPageContent();
  }

  back(): void {
    this.generalServe.back();
  }

  getPageContent(): void {
    this.httpDash.getEmpAssistance().subscribe((res) => {
      this.content = res.data;
    });
  }
}
